import type { InjectionKey } from 'vue'
import type { UIDialogInstance, UIDialogSequenceContext } from '../types'

export const UIDIALOG_KEY = Symbol() as InjectionKey<UIDialogInstance>

export const UIDIALOG_SEQUENCE_KEY = Symbol() as InjectionKey<UIDialogSequenceContext>

// Longest the sheet shows its loader before it gives up waiting and shows what it has.
export const DIALOG_SEQUENCE_LOADER_MAX_MS = 8000

// Notification type the sequence shows as its toast: `useNotifications().add({ type, value: { message } })`.
export const DIALOG_SEQUENCE_TOAST_TYPE = 'core:dialog-sequence-toast'

export const DIALOG_SEQUENCE_TOAST_MS = 4200

export const DIALOG_STEP_PRIORITY = {
    mobileAppVersion: 900,
    // In-game safer-gambling messages: they stop play, so nothing queues ahead of them.
    realityCheck: 880,
    playgameMessage: 870,
    // Opened from a link, usually on top of another step (an interrupting step).
    promotionTerms: 850,
    // Opened by the player, so they go before anything queued on their own.
    changePassword: 800,
    reviewReminder: 790,
    // Closing the deposit page (minimal layout) while a deposit is in progress.
    leaveDeposit: 785,
    bonusAction: 780,
    // Signup found the player's details on an account: asked on top of the signup.
    accountExist: 775,
    passkeyDelete: 770,
    magicLinkRequest: 765,
    bonusPlay: 760,
    unprocessedWithdrawals: 750,
    kyc: 745,
    intercomUnavailable: 735,
    generalTerms: 700,
    cookieNotice: 690,
    privacyPolicy: 650,
    missingPhone: 600,
    blockExpired: 550,
    notification: 500,
    recurringConsent: 400,
    moneyLimits: 300,
    passkeyRegistration: 250,
    promotion: 200,
    appInstall: 180,
    userLoggedOut: 150,
    promotionExpired: 120,
    magicLink: 100,
    // Signup's "Leaving already?", on top of the auth step.
    authLeave: 90,
    auth: 80,
} as const
